module.exports = __webpack_public_path__ + "img/793.6fc9b9a5.png";